import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ServiceTemplate } from "../../../types";
import { serviceTemplateService } from "../../../services/serviceTemplatesService";

export const useUpdateServiceTemplate = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      serviceTemplateId,
      serviceTemplate,
    }: {
      serviceTemplateId: string;
      serviceTemplate: Partial<{
        name: string;
        description: string;
        type: ServiceTemplate["type"];
        kpiIds: string[];
      }>;
    }) => {
      const updated = await serviceTemplateService.patch(
        serviceTemplateId,
        serviceTemplate,
      );
      return { updated, serviceTemplateId };
    },
    onSuccess: ({ updated, serviceTemplateId }) => {
      qc.setQueryData(["service-template", updated.id], updated);
      qc.invalidateQueries({ queryKey: ["service-template", serviceTemplateId] });
      qc.invalidateQueries({ queryKey: ["service-templates"] });
    },
  });
};
